'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AvailabilityOption;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _OptionHeader = require('components/TemplateComponents/common/OptionHeader');

var _OptionHeader2 = _interopRequireDefault(_OptionHeader);

var _AvailJourneys = require('./AvailJourneys.jsx');

var _AvailJourneys2 = _interopRequireDefault(_AvailJourneys);

var _emailStyleTools = require('helpers/emailStyleTools');

var _basketHelpers = require('helpers/basketHelpers');

var _dateTimeHelper = require('helpers/dateTimeHelper');

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AvailabilityOption(props) {
  var components = props.components,
      option = props.option,
      optionNumber = props.optionNumber,
      t = props.t;

  var styleFlightOptionContainer = (0, _emailStyleTools.containerStyles)(components, 'FlightOptionContainer');
  var styleFlightOptionLabel = (0, _emailStyleTools.textStyles)(components, 'FlightOptionLabel');
  var departure = _dateTimeHelper2.default.getDate((0, _basketHelpers.getAirAvailabilityDepartureDate)(option));
  var origin = (0, _basketHelpers.getAirAvailabilityOrigin)(option).cityName || (0, _basketHelpers.getAirAvailabilityOrigin)(option).code;
  var destination = (0, _basketHelpers.getAirAvailabilityDestination)(option).cityName || (0, _basketHelpers.getAirAvailabilityDestination)(option).code;

  return _react2.default.createElement(
    'table',
    {
      style: _emailStyleTools.fullMinimal,
      'data-component': 'AvailabilityOption'
    },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_OptionHeader2.default, {
            containerStyle: styleFlightOptionContainer,
            textStyle: styleFlightOptionLabel,
            text: t('common.option') + ' ' + optionNumber })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_AvailJourneys2.default, {
            journeys: (0, _basketHelpers.getAirAvailabilityJourneys)(option),
            departure: departure,
            destination: destination,
            origin: origin
          })
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/AvailabilityOption.jsx
// module id = 1475
// module chunks = 0